import * as myConstClass from "../Config/config.js";
import { useNavigate } from "react-router-dom";
import { Playstatus, Playtracking } from "../Model/Player"; //Include Home
import { GetvisionCheck, Getfaq } from "../Model/Common";
import { page } from "../Model/Content"; //Include Home
//Include Home
var CryptoJS = require("crypto-js");
export async function Encrypt(postdata) {
  var ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(postdata),
    myConstClass.SECRET_KEY
  ).toString();
  return ciphertext;
}
export async function Decrypt(postdata) {
  var bytes = CryptoJS.AES.decrypt(postdata, "DOCUBAY@WEB@APP@123");
  var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}
export async function VirsionCheck() {
  return await GetvisionCheck().then((res) => {
    return res;
  });
}

export async function extractUTMParams(url) {
  const searchParams = new URL(url);
  const queryParams = searchParams.searchParams;
  const utmSource = queryParams.get("utm_source");
  const utmMedium = queryParams.get("utm_medium");
  const utmCampaign = queryParams.get("utm_campaign");
  const click_id = queryParams.get("click_id")
  return { utmSource, utmMedium, utmCampaign, click_id };
}

// export async function getslug(string, position) {
//   position = position;
//   var stringData = string.split("/");
//   if (stringData.length > position) {
//     return stringData[position];
//   } else {
//     return null;
//   }
// }

export async function getSlug(string, position) {
  const stringData = string.split("/");
  if (stringData.length > position) {
    return stringData[position];
  }
  return null; // This will be executed if the condition in if statement fails
}

export async function PageData(pagedata) {
  return page(pagedata).then((res) => {
    return res;
  });
}

export async function SVGIcons() {
  const Icons = importAll(
    require.context("../img/svg", false, /\.(png|jpe?g|svg)$/)
  );
  return Icons;
}

export async function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
export async function ImgIcons() {
  const images = importAll(
    require.context("../img", false, /\.(png|jpe?g|svg)$/)
  );
  return images;
}

export async function Imgbanner() {
  const images = importAll(
    require.context("../img/banner", false, /\.(png|jpe?g|svg)$/)
  );
  return images;
}

export async function Advbanner() {
  const images = importAll(
    require.context("../img/adv", false, /\.(png|jpe?g|svg)$/)
  );
  return images;
}

// export async function getDateInfo(date) {
//   var date = new Date();
//   // var date1 = date.toDateString();
//   // console.log("date1",date1);
//   var dd = date.getFullYear() + "-" + date.getMonth() + 1 + "-" + date.getDate();

//   console.log(dd);
//   return `${date.getFullYear() + "-" + date.getMonth() + 1 + "-" + date.getDate()}`
// }

export async function Faq(type = "", limit = "") {
  return await Getfaq(type, limit).then((res) => {
    return res;
  });
}

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    // any other hooks can be added and passed on
    return <Component navigate={navigate} {...props} />;
  };

  return Wrapper;
};

export async function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    return (images[item.replace("./", "")] = r(item));
  });
  return images;
}

export const getcolors = [
  "#e1bb17",
  "#6a2a35",
  "#de404c",
  "#2e785e",
  "#0b4632",
  "#566fce",
  "#367014",
  "rgb(135 146 62)",
  "rgb(234 212 59)",
  "rgb(163 168 134)",
  "rgb(167 130 109)",
  "rgb(13 82 105 / 59%)",
];

export async function PlainSlidersetting() {
  return;
}

export async function Appsflyer(eventName, properties) {
  if (eventName != "" && eventName != null && eventName != undefined) {
    var EncryptedData = JSON.parse(localStorage.getItem("user-info"));

    if (EncryptedData != null) {
      return await Decrypt(EncryptedData).then((res) => {
        var UserData = res.user_data;
        var Country_code = localStorage.getItem("country_id");
        let currentBrowser = "Not known";
        if (window.navigator.userAgent.indexOf("Chrome") !== -1) {
          currentBrowser = "Google Chrome";
        } else if (window.navigator.userAgent.indexOf("Firefox") !== -1) {
          currentBrowser = "Mozilla Firefox";
        } else if (window.navigator.userAgent.indexOf("MSIE") !== -1) {
          currentBrowser = "Internet Exployer";
        } else if (window.navigator.userAgent.indexOf("Edge") !== -1) {
          currentBrowser = "Edge";
        } else if (window.navigator.userAgent.indexOf("Safari") !== -1) {
          currentBrowser = "Safari";
        } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
          currentBrowser = "Opera";
        } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
          currentBrowser = "YaBrowser";
        } else {
          console.log("Others");
        }

        //return currentBrowser;
        var afproperties = {
          name: UserData.name,
          identity: UserData.ID,
          email: UserData.email,
          device: "WEB",
          country: Country_code,
          ip: "ip",
          useragent: currentBrowser,
          requesturl: "requesturl",
        };
        afproperties = Object.assign(afproperties, properties);
        window.AF("pba", "event", {
          eventType: "EVENT",
          eventValue: afproperties,
          eventName: eventName,
        });
      });
    } else {
      return null;
    }
  }
}

// export async function branchIO(eventName, properties) {
//   if (eventName != "" && eventName != null && eventName != undefined) {
//     var EncryptedData = JSON.parse(localStorage.getItem("user-info"));

//     if (EncryptedData != null) {
//       return await Decrypt(EncryptedData).then((res) => {
//         var UserData = res.user_data;
//         var Country_code = localStorage.getItem("country_id");
//         let currentBrowser = "Not known";
//         if (window.navigator.userAgent.indexOf("Chrome") !== -1) {
//           currentBrowser = "Google Chrome";
//         } else if (window.navigator.userAgent.indexOf("Firefox") !== -1) {
//           currentBrowser = "Mozilla Firefox";
//         } else if (window.navigator.userAgent.indexOf("MSIE") !== -1) {
//           currentBrowser = "Internet Exployer";
//         } else if (window.navigator.userAgent.indexOf("Edge") !== -1) {
//           currentBrowser = "Edge";
//         } else if (window.navigator.userAgent.indexOf("Safari") !== -1) {
//           currentBrowser = "Safari";
//         } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
//           currentBrowser = "Opera";
//         } else if (window.navigator.userAgent.indexOf("Opera") !== -1) {
//           currentBrowser = "YaBrowser";
//         } else {
//           console.log("Others");
//         }

//         //return currentBrowser;
//         var bIOproperties = {
//           name: UserData.name,
//           identity: UserData.ID,
//           email: UserData.email,
//           device: "WEB",
//           country: Country_code,
//           ip: "ip",
//           useragent: currentBrowser,
//           requesturl: "requesturl",
//         };
//         bIOproperties = Object.assign(bIOproperties, properties);
//         window.branch.logEvent(eventName,
//         bIOproperties,
//         function(err) { console.log(err); }
//         );
//       });
//     } else {
//       return null;
//     }
//   }
// }

export async function playstatus(type = "", duration, content_id, Xr) {
  Playstatus(type, duration, content_id, Xr).then((resp) => {
    return true;
  });
}

//Play Tracking Common function
export async function playtracking(type, duration, content_id, title) {
  Playtracking(type, duration, content_id, title).then((resp) => {
    return true;
  });
}
export async function Getimg(Imgdata, type) {
  if (type == "V") {
    var Bannerimg;
    if (Imgdata.vertical_banner.medium) {
      Bannerimg = Imgdata.vertical_banner.medium;
    } else if (Imgdata.vertical_banner.large) {
      Bannerimg = Imgdata.vertical_banner.large;
    } else {
      Bannerimg = Imgdata.vertical_banner.small;
    }
    return Bannerimg;
  }
}
export async function getMeta(pagetype, pagetitle, content) {
  var meta = [];
  meta["keywords"] = "";
  meta["title"] = "Welcome to DocuBay - A home for global documentaries";
  meta["description"] =
    "Watch documentaries, trailers, docubytes Online | DocuBay";
  meta["url"] = myConstClass.FRONT_END;
  meta["image"] = "";
  var pagetitleText;
  if (pagetype == "HOME") {
    meta["title"] =
      "DocuBay - Watch Documentaries Online, Documentary Films & Series Online";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Stream captivating documentary feature films & series from around the world on many topics like Crime, Humanity, Culture, Science, Technology,History, Travel, Nature, Environment & more. Award winning, handpicked titles of DocuBay showcase the interconnected world as One Tribe, with Many Stories, that matter. Start Watching for free.";
    meta["url"] = myConstClass.FRONT_END + "/";
  } else if (pagetype == "LOGIN") {
    meta["title"] = "Login - DocuBay";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Login to your DocuBay account and experience the best in documentary storytelling. Stream documentaries on a variety of topics, including nature, science, history, and more.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "MOVIES") {
    meta["title"] = "Watch Documentary Films On DocuBay	";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Discover a diverse collection of award-winning documentary films from around the world on DocuBay. With our extensive library, you'll find compelling stories that inform, entertain, and inspire. Our documentaries cover a wide range of topics, from history and culture to science and technology, and everything in between. ";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "SERIES") {
    meta["title"] = "Watch Documentary Series On DocuBay";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Get hooked on DocuBay's riveting episodic documentary series. Explore thought-provoking documentaries from around the world, covering topics ranging from science and nature to politics and humanity.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "CREATEACCOUNT") {
    meta["title"] =
      "DocuBay - Watch Documentaries Online & Watch Films, Series Online";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Watch award winning documentaries from around the world on topics like Crime, Science, Nature, Culture, Politics, Technology, Travel, History and more.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "BECOME-MEMBER") {
    meta["title"] =
      "DocuBay Membership Plans - Get Access to Premium Documentaries	";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Ready to dive into the world of documentaries? DocuBay's membership plans offer unlimited access to our entire library of documentaries. Choose from monthly, quarterly, and annual membership plans, and start streaming premium documentary films and series.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "PROFILE") {
    meta["title"] = "Profile - DocuBay - One Tribe. Many Stories.";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay is the home for streaming documentaries from around the globe. Join the Tribe and watch award-winning documentary films on Nature, Science, Adventure, Travel, Culture, and more. Enjoy exclusive trailers, quick-view DocuBytes, and a New Release every day. Login to our website, or get the DocuBay app from Play Store and App Store.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "ACTIVATE-TV") {
    meta["title"] = "Active-TV - DocuBay - One Tribe. Many Stories.";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay is the home for streaming documentaries from around the globe. Join the Tribe and watch award-winning documentary films on Nature, Science, Adventure, Travel, Culture, and more. Enjoy exclusive trailers, quick-view DocuBytes, and a New Release every day. Login to our website, or get the DocuBay app from Play Store and App Store.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "MANAGE-DEVICE") {
    meta["title"] = "Manage-Devices - DocuBay - One Tribe. Many Stories.";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay is the home for streaming documentaries from around the globe. Join the Tribe and watch award-winning documentary films on Nature, Science, Adventure, Travel, Culture, and more. Enjoy exclusive trailers, quick-view DocuBytes, and a New Release every day. Login to our website, or get the DocuBay app from Play Store and App Store.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "PRIVACY-POLICY") {
    meta["title"] = "Privacy Policy - DocuBay";
    meta["keywords"] =
      "At DocuBay, we value your privacy and take protecting your information seriously. Our privacy policy outlines our commitment to safeguarding your data.";
    meta["description"] =
      "At DocuBay, we value your privacy and take protecting your information seriously. Our privacy policy outlines our commitment to safeguarding your data.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "CONTACT-US") {
    meta["title"] = "Contact Us";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay is the home for streaming documentaries from around the globe. Join the Tribe and watch award-winning documentary films on Nature, Science, Adventure, Travel, Culture, and more. Enjoy exclusive trailers, quick-view DocuBytes, and a New Release every day. Login to our website, or get the DocuBay app from Play Store and App Store.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "NEWS") {
    meta["title"] = "News";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay's news section brings you the most important updates related to latest happenings around the world of documentaries at DocuBay.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == content?.title) {
    meta["title"] =
      "Watch - " +
      content?.title +
      " documentary" +
      `${content?.content_type == "VIDEO" ? " film" : " series"}` +
      " online";
    meta["keywords"] = content?.all_keywords;
    meta["description"] = content?.description;
    meta["url"] = myConstClass.FRONT_END + "/" + content?.slug;
  } else if (pagetype == "GENERATE-PIN") {
    meta["title"] = "Generate Pin";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay is the home for streaming documentaries from around the globe. Join the Tribe and watch award-winning documentary films on Nature, Science, Adventure, Travel, Culture, and more. Enjoy exclusive trailers, quick-view DocuBytes, and a New Release every day. Login to our website, or get the DocuBay app from Play Store and App Store.";
    meta["url"] = myConstClass.FRONT_END + "/generatepin";
  } else if (pagetype == "ABOUT-US") {
    meta["title"] = "About DocuBay - The Home of International Documentaries";
    meta["keywords"] =
      "DocuBay OTT platform documentary streaming service global documentaries award-winning documentaries international documentaries video on demand documentary films factual programming documentary streaming platform";
    meta["description"] =
      "DocuBay is a premium global streaming platform that offers a wide range of documentary films and series from around the world across multiple genre. Whether you're a true history buff or a nature lover, you'll find something to love on DocuBay.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "HELP-SUPPORT") {
    meta["title"] = "Help and Support - DocuBay";
    meta["keywords"] =
      "Need help with DocuBay? Visit our help and support page to get answers to your questions, read our FAQs, or get in touch with our customer support team.";
    meta["description"] =
      "Need help with DocuBay? Visit our help and support page to get answers to your questions, read our FAQs, or get in touch with our customer support team.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "FORGOT-PASSWORD") {
    meta["title"] = "DocuBay - Reset Password.";
    meta["url"] = myConstClass.FRONT_END + "/forgot-password";
  } else if (pagetype == "TERMS") {
    meta["title"] = "Terms Of Use - DocuBay";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "Read DocuBay's Terms of Use to learn about the terms and conditions that govern your use of our OTT platform.";
    meta["url"] = myConstClass.FRONT_END + "/createaccount";
  } else if (pagetype == "BAY") {
    // meta['title'] = 'DocuBay - ' + pagetitle + ' documentaries, trailers, and DocuBytes to watch online';

    if (pagetitle == "nature") {
      meta["title"] = "Watch Stunning Nature Documentaries - DocuBay";

      meta["description"] =
        "Experience the magnificence of Mother Nature with DocuBay's exclusive collection of documentaries on Nature. From the depths of the ocean to the peaks of the mountains, witness the wonders of our planet with our awe-inspiring collection of documentary films and series.";
    } else if (pagetitle == "science") {
      meta["title"] = "Dive into the World of Science Documentaries - DocuBay	";

      meta["description"] =
        "Unlock the secrets of the Universe with ScienceBay's collection of documentaries. From the smallest particles to the largest galaxies, DocuBay's documentary films and series cover everything from the depths of the ocean to the furthest reaches of space.";
    } else if (pagetitle == "adventure") {
      meta["title"] =
        "Adrenaline Fueled Documentaries From Around the Globe - DocuBay";

      meta["description"] =
        "Get your heart racing with AdventureBay on DocuBay. From mountaineering to ocean exploration, documentaries on DocuBay have it all. Our collection of adrenaline-fueled documentaries features daring adventurers pushing the limits of human endurance and exploring the unknown.";
    } else if (pagetitle == "crime") {
      meta["title"] =
        "Gripping Crime Documentaries from Around the World  - DocuBay";

      meta["description"] =
        "DocuBay's CrimeBay documentaries take you on a journey into the darkest corners of the human psyche. Our documentary films and series explore the complex motives and actions behind some of the most shocking crimes in history. Watch documentaries that offer an in-depth look at the world of crime and justice, with a focus on compelling storytelling and thought-provoking analysis. ";
    } else if (pagetitle == "eco") {
      meta["title"] =
        "Watch Stunning Documentaries on the Wonders of Ecology - DocuBay";

      meta["description"] =
        "DoucBay's EcologyBay documentaries offer a window into the vital and fragile ecosystems of our planet. From the depths of the ocean to the heart of the rainforest, explore our planet's diverse ecosystems and the challenges they face through our curated collection of compelling documentary films and series.";
    } else if (pagetitle == "politics") {
      meta["title"] = "Compelling Political Documentaries Online - DocuBay";

      meta["description"] =
        "Dive into the complex world of politics with our expertly crafted documentaries on PoliticsBay, covering everything from historical elections to modern-day activism. Explore the world of politics and the people behind the headlines with DocuBay’s extensive collection of documentary films and series.";
    } else if (pagetitle == "tech") {
      meta["title"] =
        "Tech Documentaries to Keep You Informed and Entertained - DocuBay";

      meta["description"] =
        "TechBay's documentaries take you on a journey through the tech world. From AI to blockchain, stay ahead of the curve with DoucBay's expertly crafted documentary films and series that bring you the stories behind the technology that's shaping our world.";
    } else if (pagetitle == "action") {
      meta["description"] =
        "Stream documentaries about action, adventure, crime, and more on DocuBay. Discover true crime stories that will shock you, trek through mountains, jungles and wide, open grasslands, and meet real-life heroes out to save the world - all on DocuBay. Join the Tribe today to watch award-winning documentary titles from around the globe on your device.";
    } else if (pagetitle == "travel") {
      meta["title"] =
        "Comprehensive Collection of Travel Documentaries - DocuBay";

      meta["description"] =
        "Immerse yourself in the wonders of the world with TravelBay on DocuBay. Our collection of travel documentaries will transport you to far-flung destinations and inspire your next adventure. From hidden gems to popular destinations, explore the world through our award-winning travel documentary films and series.";
    } else if (pagetitle == "culture") {
      meta["title"] =
        "Documentaries Exploring Diverse World Cultures - DocuBay";

      meta["description"] =
        "Experience the beauty and diversity of human culture with CultureBay on DocuBay. Our collection of documentaries offers a unique perspective on the world's cultural heritage, from ancient civilizations to modern-day traditions. These documentary films and series take you on a journey of discovery, exploring the customs, traditions, and beliefs of people from around the world.";
    } else if (pagetitle == "biography") {
      meta["description"] =
        "Stream biographies, historical accounts, and other documentaries on DocuBay. Explore the lives of sportsmen who set world records, real-life crime-fighters and criminals, writers and other artists - all on DocuBay. Discover the secrets of their success and motivation. Login today to watch award-winning documentary titles from around the world on your device.";
    } else if (pagetitle == "humanity") {
      meta["title"] =
        "Powerful Documentaries on the Human Experience - DocuBay	";

      meta["description"] =
        "Explore the depths of human emotions with the best documentaries on humanity. From heartwarming stories to hard-hitting issues, HumanityBay has it all. Our award-winning documentary films and series will make you question, think and feel.";
    } else if (pagetitle == "history") {
      meta["title"] =
        "Fascinating Collection of Historical Documentaries - DocuBay";

      meta["description"] =
        "Discover the hidden truths of the past with DocuBay's HistoryBay documentary films and series. From the pyramids of Egypt to the battlefields of World War II, our collection of historical documentaries offers a unique and compelling look at the events that shaped our world.";
    } else if (pagetitle == "war") {
      meta["title"] = "Explore the World of War Documentaries - DocuBay";

      meta["description"] =
        "WarBay on DocuBay brings you gripping documentaries on the world's most significant conflicts. Discover the untold stories of soldiers, civilians, and communities affected by war. From the front lines to the home front, these powerful documentary films and series offer insight into the causes, effects, and consequences of war.";
    }
  } else {
    meta["title"] = "DocuBay - One Tribe. Many Stories.";
    meta["keywords"] =
      "Prime Video DocuBay,Docubay app,Docubay documentaries,Docubay movies,www primevideo Docubay,Docubay documentaries free downloads,Docu bay,Docubay prime video,www primevideo com Docubay,Prime video docubay,Primevideo.com docubay,Documentaries,documentary,Docubay streaming documentaries,Docubay streaming,how to watch docubay in amazon prime,best documentaries on docubay,docubay series,Award winning documentaries,Docubay subscription";
    meta["description"] =
      "DocuBay is the home for streaming documentaries from around the globe. Join the Tribe and watch award-winning documentary films on Nature, Science, Adventure, Travel, Culture, and more. Enjoy exclusive trailers, quick-view DocuBytes, and a New Release every day. Login to our website, or get the DocuBay app from Play Store and App Store.";
  }
  return meta;
}
